import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BusinessCard from './BusinessCard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BusinessCard />
  </React.StrictMode>
);
